<template>
  <div class="question-container control-container">
    <h2>Questions</h2>

    <div v-if="!questions || questions.length <= 0">
      <span style="font-style:italic">No questions</span>
    </div>

    <b-tooltip size="is-large" v-for="(question, index) in questions" :key="index" :label="question.text"  type="is-light"
          position="is-left"
          square>
          <button :class="{removed: question.removed, 'question-item':true, 'button':true}" @click="onQuestionRemoved(question, !question.removed)"> 
          {{simplifiedQuestion(question)}}
         
          <v-icon v-if="!question.removed" small class="question-icon">check</v-icon>
      </button>
    </b-tooltip>

  </div>
</template>

<script>
export default {
  name: 'Questions',
  props: ['question','values'],
  data() {
    return{
      questions: this.values
    }
  },
  computed:{
    className() {
        return "button item-"+ this.question.type ;
    },
    transcriptId(){
      return this.$route.params.transcript.transcriptId;
    }
  },
  methods:{
    simplifiedQuestion(question){
      return question.text.substring(0,35)+'...';
    },
    onQuestionRemoved(question, removed){
      const me = this
      me.$store.commit('setQuestionsState',{transcriptId:me.transcriptId, text:question.text, removed:removed});
      me.questions = JSON.parse(JSON.stringify(me.$route.params.transcript.questions))
    }
  }
}
</script>

<style scoped>
.question-item{
  text-align: left;
  background:#F8b632;
  color:white;
}
.question-icon{
    position: absolute;
    color: #3ad6af;
    /* font-size: 1.5em; */
    right:20px;
}
.removed{
  opacity: 0.5;
}
.tooltip{
  width:100%;
}
.tooltip::after{
  font-size: 12px;
}
</style>